import React from 'react'
import {observer} from 'mobx-react-lite'
import {EquipmentModels} from '@s2a/sdk-equipment-models'
import {
    iconList,
    IconProps,
    EnterpriseIcon,
    SubsidiaryIcon,
    PlantIcon,
    AreaIcon,
    LineIcon,
    MachineGroupIcon,
    IconByKey,
    MachineIcon,
    ComponentIcon
} from '@oc/icons'

const {Enterprise, Subsidiary, Plant, Area, Line, Machine, MachineGroup, Component} = EquipmentModels.EquipmentLevels

export function getS2AIconKeyByEquipmentType(equipmentType: string): string | undefined {
    return iconList.find(icon => icon.s2aName === `equipment_${equipmentType}`)?.s2aName
}

export function getOcEquipmentIcon(level: string, equipmentType?: string, props?: IconProps) {
    switch (level) {
        case Enterprise:
            return <EnterpriseIcon {...props} />
        case Subsidiary:
            return <SubsidiaryIcon {...props} />
        case Plant:
            return <PlantIcon {...props} />
        case Area:
            return <AreaIcon {...props} />
        case Line:
            return <LineIcon {...props} />
        case MachineGroup:
            return <MachineGroupIcon {...props} />
        case Machine: {
            const iconKey = getS2AIconKeyByEquipmentType(equipmentType || '')
            if (iconKey) {
                return <IconByKey {...props} iconKey={iconKey} />
            }
            return <MachineIcon {...props} />
        }
        case Component:
            return <ComponentIcon {...props} />
        default:
            return <ComponentIcon {...props} />
    }
}

function _OcEquipmentIcon(props: IconProps & {level: string; equipmentType?: string}) {
    const {level, equipmentType, ...iconProps} = props
    const icon = React.useMemo(() => {
        return getOcEquipmentIcon(level, equipmentType, iconProps)
    }, [level, equipmentType, iconProps])

    return icon
}

export const OcEquipmentIcon = observer(_OcEquipmentIcon)
